export interface DateProps {
  fullYear?: boolean;
}

const handleDateFalsy = (date?: Date | null) => !!date;

const addLeftZero = (num?: number) => {
  if (!num) {
    return '';
  }
  const stringNum = num + '';
  return stringNum?.length === 1 ? '0' + stringNum : stringNum;
};

const yearMode = (year?: Date | null, isFullYear: boolean = true) =>
  !year
    ? ''
    : isFullYear
      ? year.getUTCFullYear()
      : year.getFullYear().toString().substring(2, 4);

export const localDateFormate = {
  en: (date?: Date | null, props?: DateProps) =>
    handleDateFalsy(date)
      ? `${addLeftZero((date?.getUTCMonth() ?? -1) + 1)}/${addLeftZero(
          date?.getUTCDate(),
        )}/${yearMode(date, props?.fullYear)}`
      : '',
  'pt-BR': (date?: Date | null, props?: DateProps) =>
    handleDateFalsy(date)
      ? `${addLeftZero(date?.getUTCDate())}/${addLeftZero(
          (date?.getUTCMonth() ?? -1) + 1,
        )}/${yearMode(date, props?.fullYear)}`
      : '',
};

export const localeMapFormat = {
  en: {
    days: 'MM/dd/yyyy',
    months: 'MM/yyyy',
    years: 'yyyy',
  },
  'pt-BR': {
    days: 'dd/MM/yyyy',
    months: 'MM/yyyy',
    years: 'yyyy',
  },
};

/**
 * Não é possível utilizar o react-input-mask junto com o datepicker, por conflito de implementação dos métodos onBlur e onFocus.
 * @param value Valor do input do usuário.
 * @returns
 */
export const datePickerInputMask = (value?: string): string => {
  if (!value) {
    return '';
  }
  let newValue = value;
  newValue = newValue?.replace(/\D/g, '');
  newValue = newValue?.replace(/(\d{2})(\d)/, '$1/$2');
  newValue = newValue?.replace(/(\/\d{2})(\d)/, '$1/$2');
  if (newValue?.length > 10) {
    newValue = newValue?.substring(0, 10);
  }
  return newValue;
};
